import React from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';

import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';
import {Typography,Modal,Button} from '@material-ui/core';

import Alerta from '../../../../../../../util/snackbars/.mixins/';
import Config from '../../../../../../../../controllers/config';

import Modal_RemoveCss from './Modal_Remove-css';
const styles = Modal_RemoveCss();

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class SimpleModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      id: null
    };
    this.inputRef = React.createRef();
    this.child = React.createRef();
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(id){
    this.setState({ open: true });
    this.setState({ id: id });
  };

  handleClose(){
    setTimeout(() => {
      this.setState({ open: false });
    }, 200);
  };

  async sendRemove(props){
    var retorno = null;
    
    const cookies = new Cookies();
    await fetch(Config.URL_BACKEND+'/'+props.props.pai.props.route.title+'/'+props.state.id, {
      method: 'delete',
      headers: {
        'Content-Type':'application/json',
        'User-Token': cookies.get('User-Token')
      }
    }).then(function (a) {
      return a.json();
    })
    .then(function (json) {
      retorno = json;
    })

    if (retorno.status)
      this.child.current.retorno(retorno.message,'success');
    else
      this.child.current.retorno('Não foi possível remover '+this.props.pai.props.message+'!','error');

    //fecha modal
    props.handleClose();

    //chama funcao do pai para atualizar a lista
    this.props.pai.loadData(props.props.pai, null);
      
  }

  render() {
    const { classes } = this.props;
    
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div style={getModalStyle()} className={classes.paper}>
            <Typography type="title" id="modal-title" className={classes.tituloModalRemove}>
                <DeleteIcon />
                Remover item
            </Typography>
            <Typography type="subheading" id="simple-modal-description">
              Deseja realmente remover esse item?
            </Typography>
            <br/>
            <div align="right">
                <Button className={classes.buttonCancelar} onClick={this.handleClose}>
                    Não
                </Button>
                <Button variant="contained" className={classes.buttonRemover} onClick={(e)=>{this.sendRemove(this)}}>
                    Sim
                </Button>
            </div>
            <SimpleModalWrapped />
          </div>
        </Modal>
        <Alerta ref={this.child}/>
      </div>
    );
  }
}

SimpleModal.propTypes = {
  classes: PropTypes.object.isRequired,
};


const SimpleModalWrapped = withStyles(styles)(SimpleModal);

export default SimpleModalWrapped;